import React from "react";

import './nav.css';  // Import the Nav component's CSS (optional)

const Nav = () => {
    return (

<nav class="navbar navbar-expand-lg static-top">
  <div class="container">
    <a class="navbar-brand" href="/">
      <img src="./img/reis.png" alt="Logo" />
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i className="fas fa-bars "></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="/">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/">Solution</a>
        </li>        
        <li class="nav-item">
          <a class="nav-link" href="/">Government</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/">Contact</a>
        </li>
        <li><a href="/" className="btn btn-default btn-green video-btn"><img src="/img/video.png" alt="icon" />Meet with us</a></li>
      </ul>
    </div>
  </div>
</nav>
);
};

export default Nav;